var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { tile: "", color: _vm.color } },
    [
      _c(
        "v-card-title",
        [
          _c("v-icon", { attrs: { large: "", left: "" } }, [_vm._v("warning")]),
          _vm._v(" "),
          _c("span", { staticClass: "headline" }, [_vm._v(_vm._s(_vm.label))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "py-2" }, [
        _c("span", { staticClass: "subheading" }, [
          _vm._v(_vm._s(_vm.sublabel)),
        ]),
      ]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "white" },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _vm._l(_vm.messages, function (msg, index) {
                return [
                  _c(
                    "v-list-tile",
                    { key: index },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { color: "error" } },
                        [_vm._v("clear")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "body-1" }, [
                        _vm._v(_vm._s(msg.Message)),
                      ]),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }